import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Checkboxes, Button, ErrorSummary, Fieldset } from 'govuk-react-jsx';
import {
  getParkingTypesSelected,
  setParkingTypeSelected,
} from '../../features/application/applicationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { getSelectedLandlordClient } from '../../features/pmc/pmcJourneySlice';
import useTitle from '../../hooks/useTitle';

const ParkingType = ({ location }) => {
  const parkingTypeSelected = useSelector(getParkingTypesSelected);
  const isFromCheckAnswers = location?.state?.isFromCheckAnswers;
  const history = useHistory();
  const dispatch = useDispatch();
  const [hasError, setHasError] = useState(false);
  const [errorList, setErrorList] = useState([]);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const currentUserData = useSelector(getSelectedLandlordClient);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'pmcApp.ParkingType.s9',
    'What type of car park is it? - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const selectErrorMsg = copyProvider.getCopy(
    'landlordReg.ParkingType.s8',
    'Select the type of car park'
  );

  const handleButtonClick = () => {
    if (parkingTypeSelected?.length <= 0) {
      setHasError(true);
      setErrorList([{ children: selectErrorMsg, href: '#firstOption' }]);
    } else {
      setHasError(false);
      if (isFromCheckAnswers) {
        history.push('/pmcApp/check-your-answers');
      } else {
        history.push('/pmcApp/number-of-chargepoints');
      }
    }
  };

  const handleSelection = (event) => {
    if (event.target.checked) {
      dispatch(
        setParkingTypeSelected([...parkingTypeSelected, event.target.value])
      );
    } else {
      const temp = [...parkingTypeSelected];
      temp?.splice(
        temp.findIndex((parkingType) => parkingType === event.target.value),
        1
      );
      dispatch(setParkingTypeSelected(temp));
    }
  };

  const pageModel = (
    <div>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <span className="govuk-caption-l">
        {currentUserData != null &&
          currentUserData.landlord_account_name != null &&
          currentUserData.landlord_account_name}
      </span>

      <Fieldset
        legend={{
          children: (
            <h1 className="govuk-heading-xl">
              {copyProvider.getCopy(
                'pmcApp.ParkingType.s1',
                'What type of car park is it?'
              )}
            </h1>
          ),
        }}
      >
        <h3 className="govuk-hint">
          {copyProvider.getCopy(
            'pmcApp.ParkingType.s2',
            'Select all that apply'
          )}
        </h3>
        <Checkboxes
          onChange={(event) => handleSelection(event)}
          errorMessage={
            hasError && {
              children: selectErrorMsg,
            }
          }
          idPrefix="example"
          items={[
            {
              children: copyProvider.getCopy(
                'landlordReg.ParkingType.s3',
                'Overground surface parking'
              ),
              value: 'Overground surface parking',
              id: 'firstOption',
              checked: parkingTypeSelected.includes(
                'Overground surface parking'
              ),
            },
            {
              children: copyProvider.getCopy(
                'landlordReg.ParkingType.s4',
                'Multi-storey parking'
              ),
              value: 'Multi-storey parking',
              checked: parkingTypeSelected.includes('Multi-storey parking'),
            },
            {
              children: copyProvider.getCopy(
                'landlordReg.ParkingType.s5',
                'Underground parking'
              ),
              value: 'Underground parking',
              checked: parkingTypeSelected.includes('Underground parking'),
            },
            {
              children: copyProvider.getCopy(
                'landlordReg.ParkingType.s6',
                'Garages'
              ),
              value: 'Garages',
              checked: parkingTypeSelected.includes('Garages'),
            },
          ]}
        />
      </Fieldset>
      <Button onClick={handleButtonClick}>
        {copyProvider.getCopy('pmcApp.ParkingType.s7', 'Continue')}
      </Button>
    </div>
  );
  return pageModel;
};
ParkingType.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      isFromCheckAnswers: PropTypes.bool,
    }),
  }),
};

ParkingType.defaultProps = {
  location: {
    state: {
      isFromCheckAnswers: false,
    },
  },
};
export default ParkingType;
